import { NgModule } from '@angular/core';

import { HeaderComponent } from './header/header.component';
import { AreaUtenteComponent } from './area-utente/area-utente.component';
import { FooterComponent } from './footer/footer.component';
import { MenuModule } from './menu/menu.module';
import { NotFoundComponent } from './not-found/not-found.component';
import { SharedCommonModule } from '@shared/shared-common.module';
import { WorkInProgressComponent } from './work-in-progress/work-in-progress.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        HeaderComponent,
        AreaUtenteComponent,
        FooterComponent,
        NotFoundComponent,
        WorkInProgressComponent
    ],
    imports: [
        SharedCommonModule,
        MenuModule,
        CommonModule
    ],
    exports: [
        HeaderComponent,
        AreaUtenteComponent,
        FooterComponent,
        NotFoundComponent,
        WorkInProgressComponent
    ]
})
export class LayoutModule { }
